import initCalendarButtons from '../utils/init-calendar-buttons'
import initTooltips from '../utils/init-tooltips'
import initCopyButtons from '../utils/initCopyButtons'
import initPdfButtons from '../utils/init-pdf-buttons'

const el = document.querySelector('.bhub-woocommerce-ty')

if (el) {
  initCalendarButtons(el).then(() => {
    initTooltips(el)
  })

  initCopyButtons(el)
  initPdfButtons(el)
}
